var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15V0H1.5V1.5H12L10.5 5.25L12 9H1.5V15H0ZM5.625 6.75C6.0375 6.75 6.39063 6.60312 6.68438 6.30937C6.97813 6.01562 7.125 5.6625 7.125 5.25C7.125 4.8375 6.97813 4.48437 6.68438 4.19062C6.39063 3.89687 6.0375 3.75 5.625 3.75C5.2125 3.75 4.85938 3.89687 4.56563 4.19062C4.27188 4.48437 4.125 4.8375 4.125 5.25C4.125 5.6625 4.27188 6.01562 4.56563 6.30937C4.85938 6.60312 5.2125 6.75 5.625 6.75ZM1.5 7.5H9.7875L8.8875 5.25L9.7875 3H1.5V7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartIcon);
export default __webpack_public_path__ + "static/media/restartIcon.0cfaded2d2de74d921ae80f979b0e47c.svg";
export { ForwardRef as ReactComponent };